import {
  IWorkAssignmentsDTOWrapper,
  save,
  closeWorkAssignments,
  ITeam,
  IRecruiterSearchDTO,
  getWorkAssignmentsByJobId,
} from 'wisestep-api';
import { IUserDTO } from 'wisestep-base';

import { failed, success, warning } from '../../../utils/NotificationMessages';
import { ICheckBoxListOptions } from '../assign/components/AssignedRecruiters';
import { ITeamMembers, IWorkAssignments } from '../assign/types';

export const assignments: IWorkAssignmentsDTOWrapper = {
  assignedByRecruiterId: '',
  workAssignmentDTOList: [],
  recruiterDTOList: [],
  jobDTOList: [],
  teamDTOList: [],
  vendorPartnerDTOList: [],
};

export const assign = async () => {
  if (assignments.teamDTOList.length > 0 || assignments.recruiterDTOList.length > 0) {
    try {
      await save(assignments);
      return success(`Job(s) Assigned Successfully.`);
    } catch {
      return failed(`Error in Work Assignment. Please try again.`);
    }
  } else {
    return warning('Something went wrong , Please try again !!');
  }
};

export const unAssign = async () => {
  if (assignments.teamDTOList.length > 0 || assignments.recruiterDTOList.length > 0) {
    try {
      await closeWorkAssignments(assignments);
      return success(`Job Un-assigned Successfully.`);
    } catch {
      return failed(`Failed to Unassign the Job. Please try again.`);
    }
  } else {
    return warning('Something went wrong , Please try again !!');
  }
};

export const getTeamIdsBySelectedIndices = (indices: number[], teamsData: ITeam[]) => {
  assignments.teamDTOList = [];
  indices.length > 0 &&
    indices.forEach((index) => assignments.teamDTOList.push(teamsData[index]?.id ?? ''));
  return assignments;
};

export const getRecruiterIdsBySelectedIndices = (
  indices: number[],
  recruiterData: IRecruiterSearchDTO[]
) => {
  assignments.recruiterDTOList = [];

  indices.length > 0 &&
    indices.forEach((index) => assignments?.recruiterDTOList?.push(recruiterData[index]?.email));

  return assignments;
};

export const extractDataByIndices = (indices: number[], stringArray: string[]) => {
  assignments.recruiterDTOList = [];
  indices.forEach((index) => assignments?.recruiterDTOList?.push(stringArray[index]));
  return assignments;
};

export const getNamesFromAssignments = (workAssignmentsOfTeams: IWorkAssignments) => {
  const recruitersOptions: ICheckBoxListOptions = {};
  const teamMembersOptions: ICheckBoxListOptions = {};

  workAssignmentsOfTeams?.recruiters?.forEach((recruiter) => {
    if (recruiter?.email) {
      recruitersOptions[recruiter.email] =
        (recruiter?.displayName ?? recruiter?.email) + ' (' + recruiter?.email + ')';
    }
  });

  workAssignmentsOfTeams?.teamMembers?.forEach((member) => {
    if (member.memberEmail) {
      teamMembersOptions[member.memberEmail] = member.name ?? member.memberEmail;
    }
  });
  return { ...recruitersOptions, ...teamMembersOptions };
};

export const getEmailsFromAssignments = (workAssignmentsOfTeams) => {
  const assignedTeamMembersEmailsList = workAssignmentsOfTeams?.teamMembers?.map(
    (teamMember: ITeamMembers) => teamMember.memberEmail
  );

  const assignedRecruitersEmailsList = workAssignmentsOfTeams?.recruiters?.map(
    (recruiter: IUserDTO) => recruiter?.email
  );
  return assignedRecruitersEmailsList?.concat(assignedTeamMembersEmailsList);
};

export const getWorkAssignments = async (jobId: string) => {
  const response = await getWorkAssignmentsByJobId(jobId);
  return response.data as IWorkAssignments;
};

export const assignJobToCreator = async (jobId: string, recruiter: string) => {
  const workAssignments = { ...assignments };
  workAssignments.assignedByRecruiterId = recruiter;
  workAssignments.jobDTOList = [jobId];
  workAssignments.recruiterDTOList = [recruiter];
  try {
    await save(workAssignments);
    return success(`Job(s) Assigned Successfully.`);
  } catch {
    return failed(`Error in Work Assignment. Please try again.`);
  }
};
